'use client';

import { FC, PropsWithChildren } from 'react';

import { createCustomContext } from './context';

type TProps = {
  isMobiles: boolean;
};
const [Context, useMobileContext] = createCustomContext<TProps>({
  name: 'useMobileContext',
});
export { useMobileContext };

interface MobileProviderProps extends PropsWithChildren {
  isMobiles: boolean;
}

export const MobileProvider: FC<MobileProviderProps> = ({
  children,
  isMobiles,
}) => <Context value={{ isMobiles }}>{children}</Context>;
